export const SET_APP_INITIALIZED = 'APP/SET_APP_INITIALIZED';
export const setAppInitialized = () => ({ type: SET_APP_INITIALIZED });

export const SET_SCHEDULES_START_DATE = 'APP/SET_SCHEDULES_START_DATE';
export const setSchedulesStartDate = schedulesStartDate => ({ type: SET_SCHEDULES_START_DATE, schedulesStartDate });

export const SET_GIT_SHA = 'APP/SET_GIT_SHA';
export const setGitSha = gitSha => ({ type: SET_GIT_SHA, gitSha });

export const SET_FORCE_REFRESH_ON_ROUTE_CHANGE = 'APP/SET_FORCE_REFRESH_ON_ROUTE_CHANGE';
export const setForceRefreshOnRouteChange = () => ({ type: SET_FORCE_REFRESH_ON_ROUTE_CHANGE });

const initialState = {
  appInitialized: false,
  schedulesStartDate: new Date(),
  gitSha: null,
  forceRefreshOnRouteChange: false,
};

export default (state = initialState, action) => {
  const { type, schedulesStartDate, gitSha } = action;

  switch (type) {
    case SET_APP_INITIALIZED:
      return { ...state, appInitialized: true };

    case SET_SCHEDULES_START_DATE:
      return { ...state, schedulesStartDate };

    case SET_GIT_SHA:
      return { ...state, gitSha };

    case SET_FORCE_REFRESH_ON_ROUTE_CHANGE:
      return { ...state, forceRefreshOnRouteChange: true };

    default:
      return state;
  }
};
